import { useContext } from 'react';
import { ContextData, CTAContext } from '../CTAProvider/CTAProvider';

export const useCTA = (): ContextData => useContext(CTAContext);
